import { render, staticRenderFns } from "./ListDealStatuses.vue?vue&type=template&id=2dd804a2"
import script from "./ListDealStatuses.vue?vue&type=script&lang=js"
export * from "./ListDealStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports